var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "casino-grid-container",
      attrs: { "data-grid-container-id": _vm.groupData.groupId }
    },
    [
      _vm._l(_vm.data, function(game, i) {
        return [
          _c(
            "div",
            { staticClass: "casino-grid-item" },
            [
              game && game.labels && game.labels.length > 0
                ? _c("casino-labels", {
                    staticClass: "casino-labels",
                    attrs: { labels: game.labels }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isLoggedIn
                ? _c("casino-favorites", {
                    attrs: {
                      favorite: _vm.isInFavorite(game.id),
                      gameId: game.id
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("casino-game-image", { attrs: { gameId: game.id } }),
              _vm._v(" "),
              _c("casino-jackpot-and-game-info-section", {
                attrs: { gameId: game.id }
              })
            ],
            1
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47001aa6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47001aa6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoGridView.vue
// module id = null
// module chunks = 